import { z } from "zod";
import { LookupQuerySchema, OutsourcePayeeTypeSchema } from "./common";

export const OutsourceSchema = z.object({
  id: z.string(),
  categoryId: z.string(),
  categorySlug: z.string().optional(),
  categoryName: z.string().optional(),
  payeeType: OutsourcePayeeTypeSchema,
  displayName: z.string(),
  contactName: z.string().nullable(),
  phone: z.string().nullable(),
  email: z.string().nullable(),
  bankName: z.string().nullable(),
  bankAccount: z.string().nullable(),
  bankAccountName: z.string().nullable(),
  notes: z.string().nullable(),
  isActive: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type OutsourceDTO = z.infer<typeof OutsourceSchema>;

export const CreateOutsourceSchema = z.object({
  categoryId: z.string().min(1),
  payeeType: OutsourcePayeeTypeSchema,
  displayName: z.string().trim().min(1, "ຕ້ອງປ້ອນຊື່"),
  contactName: z.string().nullable().optional(),
  phone: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  bankName: z.string().nullable().optional(),
  bankAccount: z.string().nullable().optional(),
  bankAccountName: z.string().nullable().optional(),
  notes: z.string().nullable().optional(),
  isActive: z.boolean().default(true),
});
export type CreateOutsourceDTO = z.infer<typeof CreateOutsourceSchema>;

export const UpdateOutsourceSchema = CreateOutsourceSchema.partial();
export type UpdateOutsourceDTO = z.infer<typeof UpdateOutsourceSchema>;

export { LookupQuerySchema as OutsourceLookupQuerySchema };
export type OutsourceLookupQueryDTO = z.infer<typeof LookupQuerySchema>;

export const OutsourceListQuerySchema = LookupQuerySchema.extend({
  categoryId: z.string().min(1).optional(),
  payeeType: OutsourcePayeeTypeSchema.optional(),
  status: z.enum(["active", "inactive"]).optional(),
});
export type OutsourceListQueryDTO = z.infer<typeof OutsourceListQuerySchema>;

export const BulkCreateOutsourcesFromStaffSchema = z.object({
  staffIds: z.array(z.string().min(1)).min(1, "ເລືອກຢ່າງໜ້ອຍ 1 Staff"),
  categoryId: z.string().min(1),
});
export type BulkCreateOutsourcesFromStaffDTO = z.infer<
  typeof BulkCreateOutsourcesFromStaffSchema
>;

export const BulkCreateOutsourcesFromStaffResultSchema = z.object({
  created: z.array(OutsourceSchema),
  skipped: z.array(
    z.object({
      staffId: z.string(),
      code: z.string(),
      message: z.string(),
    }),
  ),
});
export type BulkCreateOutsourcesFromStaffResultDTO = z.infer<
  typeof BulkCreateOutsourcesFromStaffResultSchema
>;
